require("./app-shell-v4.scss");
// Add class to page body so we can handle when the nav is mobi style (not all mobi devices use it)
const pageBody = document.getElementById("page-body");
if(pageBody) {
    if (document.querySelector('[data-js="mobileMenuV4Root"]'))
        pageBody.classList.add("mobi-nav");
    else
        pageBody.classList.add("desktop-nav");
}

